import React, { useEffect, useState } from 'react'

import { Container, Left, Right } from 'components/UIComponents/Toggle/style'
import { COLORS } from 'theme'

const Toggle = (
  {
    left,
    right,
    center,
    width,
    onClick,
    initialValue = 'left',
    disabled = false,
    widthRight = '130px',
    widthLeft = '111px',
  },
  props
) => {
  const [current, setCurrent] = useState()

  useEffect(() => {
    setCurrent(initialValue)
  }, [initialValue])

  const handleClick = curr => {
    if (curr == 'left') {
      setCurrent('left')
      onClick(false)
    } else if (curr == 'center') {
      setCurrent('center')
      onClick(false)
    } else {
      setCurrent('right')
      onClick(true)
    }
  }
  return (
    <Container disabled={disabled}>
      <Left
        color={current == 'left' ? COLORS.PRIMARY : '#CAD2F9'}
        background={current == 'left' ? '#EAEDFB' : COLORS.WHITE}
        onClick={() => handleClick('left')}
        disabled={disabled}
        width={widthLeft}
      >
        {left}
      </Left>

      <Right
        color={current == 'right' ? COLORS.PRIMARY : '#CAD2F9'}
        background={current == 'right' ? '#EAEDFB' : COLORS.WHITE}
        onClick={() => handleClick('right')}
        disabled={disabled}
        width={widthRight}
      >
        {right}
      </Right>
    </Container>
  )
}

export default Toggle
